import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@vds-core/utilities';
import { Fonts } from '@vds-core/typography';
import InputText from './InputText';
var propTypes = {
  errorText: PropTypes.string,
  errorMarginLeft: PropTypes.string
};
var defaultProps = {
  errorMarginLeft: calculateRem(-1)
}; // The reason for this funky padding is so that I can fix the checkbox without
// completely refactoring the svg implemenation. This will be fixed on a later pass.

var StyleCheckboxError = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyleCheckboxError",
  componentId: "VDS__sc-zzfemp-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  margin-top: 0;\n  left: ", ";\n"])), function (_ref) {
  var errorMarginLeft = _ref.errorMarginLeft;
  return errorMarginLeft;
});
/**
 * @ignore
 */

var CheckboxError = function CheckboxError(props) {
  var errorText = props.errorText,
      color = props.color,
      errorMarginLeft = props.errorMarginLeft;
  return /*#__PURE__*/React.createElement(StyleCheckboxError, {
    errorMarginLeft: errorMarginLeft
  }, /*#__PURE__*/React.createElement(InputText, {
    color: color,
    fontFamily: Fonts.VerizonNHGeTX
  }, errorText));
};

CheckboxError.propTypes = propTypes;
CheckboxError.defaultProps = defaultProps;
export default CheckboxError;